import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  imageProps: {
    uri: 'https://assets.airtel.in/static-assets/new-home/img/airtel-red.svg',
    height: 18,
    width: 76
  },
  iconName: 'AirtelFilledIcon',
  title: 'page Content title',
  subTitle: 'subtext',
  actionTypes: 'icon',
  actionIconName: 'RightChevronIcon',
  actionHealthType: 'success',
  actionCtaText: 'Button',
  showInfoIcon: true,
  infoIconTooltipProps: {
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit!',
    autoHide: true
  },
  showActionCtaWithCheveron: true
}, getTestId('CardTitleWidgetContainer'));